import React from 'react';
import { TermsOfServiceContent } from '../../../shared/legal/TermsOfServiceContent';
import LandingPolicyShell from '../components/LandingPolicyShell';

export default function TermsOfService() {
    return (
        <LandingPolicyShell title="Terms of Service">
            <TermsOfServiceContent variant="page" />
        </LandingPolicyShell>
    );
}
